/**
 * The ONE sign-out exit path. Every "sign out" affordance (the /logout
 * route, the AppShell account menu, error-state sign-out buttons) funnels
 * here so the landing surface can't drift per call site — the bug this
 * fixes was exactly that drift: /logout bounced to the central auth origin
 * while the account menu still landed on the tenant's local /login.
 *
 * Deployed tenant hosts land on the CENTRAL auth origin
 * (`login[-staging].3mote.com/login?return=<tenant>`) where the SSO buttons
 * are real one-click embeds; localhost (and any host without a central
 * twin) falls back to the local /login. `replace` semantics so the back
 * button never re-runs a sign-out.
 */

import { signOut } from '@/auth/cognito'
import { agentWorkingStore } from '@/features/agents/agent-working-store'

import { buildCentralLoginUrl } from './central-redirect'
import { hardReplace } from './hard-navigate'

export async function signOutToLogin(navigateToLocalLogin: () => void): Promise<void> {
  try {
    await signOut()
  } finally {
    // The next person to sign in on this page must not inherit this session's glows.
    agentWorkingStore.clear()
    const centralUrl = buildCentralLoginUrl(window.location.host)
    if (centralUrl) {
      hardReplace(centralUrl)
    } else {
      navigateToLocalLogin()
    }
  }
}
